import { SideMenuItemModel } from './side-menu-item-model';
import { environment } from '@root/src/environments/environment';

/**
 * The class represents a list in the format of a SideMenuItemModel collection with data about icons, titles and URLs of the settings and users section.
 */
export const SideMenuSettingsItems: SideMenuItemModel[] = [
   { icon: 'settings', title: 'Settings', url: '/settings', disabled: false },
   { icon: 'users', title: 'Users', url: '/users', disabled: false }
];
